import React, { useEffect, useState } from "react";
import { Grid, Box } from "@mui/material";
import "./AboutMeModal.css";
import CustomModal from "../../CustomModal/CustomModal";
import ModalFooter from "../../CustomModal/ModalFooter";
import ModalHeader from "../../CustomModal/ModalHeader";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import * as _ from "lodash";
import { aboutMeType } from "../../../interfaces/myProfile/personalDetails/aboutMeType";
import Loader from "../../../Lottifiers/Loader/Loader";
import Compdirection from "../../../themes/CompDirection";

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  callBackHandleClockIn: (data: aboutMeType) => void;
  aboutMeDetail: string;
  isLoading: boolean;
  trans?: any;
}

const AboutMeModalPresenter = ({
  isModalOpen,
  closeModal,
  isLoading,
  aboutMeDetail,
  callBackHandleClockIn,
  trans,
}: ModalProps) => {
  const [aboutMe, setAboutMe] = useState(aboutMeDetail);

  const handleSubmit = () => {
    callBackHandleClockIn({
      about_me: aboutMe,
    });
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="354px"
      modalWidth="600px"
    >
      <ModalHeader
        modal={{ modal_title: trans("Edit About Me") }}
        closeModal={closeModal}
      />
      <Grid
        container
        spacing={2}
        style={{
          marginTop: "15px",
        }}
      >
        {isLoading ? (
          <Loader height={100} width={200} />
        ) : (
          <Grid item xs={12}>
            <Compdirection>
              <CustomTextField
                type="string"
                label={trans("About Me")}
                placeholder={trans("About Me")}
                value={aboutMe}
                multiline={true}
                rows={4}
                onChange={(e: any) => setAboutMe(e.target.value)}
              />
            </Compdirection>
          </Grid>
        )}
      </Grid>
      <Box style={{ marginTop: "35px" }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default AboutMeModalPresenter;
